export enum PhotoType {
  LISTING_PHOTO = 'listingPhoto',
  PROFILE_PHOTO = 'profilePhoto',
}
